import React, { useEffect } from "react";
import styles from "./A23GameTableSeat.module.css";
import { FaPlus } from "react-icons/fa";
import usePlayerSeat from "@/src/hooks/data/usePlayerSeat";
import Player from "../../Player/Player";
import useGameSocket from "@/src/hooks/utils/useGameSocket";
import { usePlayerSeat as useGamePlayerSeat, useGameDefinition } from "@/src/hooks/data/useGameTable";
import { doesExist } from "../../../../Common/utils/GameUtils";
import gameAssets from "@themed-assets";
import usePlayerBalance from "@/src/hooks/data/usePlayerBalance";
import { useDispatch } from "react-redux";
import { showInsufficientBalance } from "@/Poker/redux/slices/gameTableSlice";
import Lottie from "lottie-react";

// Handle All Take Seat / Reservation Logic Here.
// Render Player Component incase the seat is already taken.
export default function GameTableSeat({
  position,
  clientChairIndex,
  tempTableId,
  coordinates,
}) {
  const playerSeat = useGamePlayerSeat(tempTableId);
  const gameDefinition = useGameDefinition(tempTableId);
  const { isTakenSeat, isReservedSeat } = usePlayerSeat(tempTableId, position);
  const { sendReserveProtocol } = useGameSocket(tempTableId);
  const { totalBalance } = usePlayerBalance();
  const dispatch = useDispatch();

  const handleReserveSeat = () => {
    console.log("Reserving seat 0", position);
    if (totalBalance < gameDefinition?.minBuyInAmount) {
      dispatch(showInsufficientBalance({ tempTableId }));
      return;
    }
    console.log("Reserving seat 1 ", position);
    if (!isTakenSeat && !isReservedSeat && !doesExist(playerSeat)) {
      console.log("Reserving seat 2", position);
      sendReserveProtocol(position);
    }
  };

  if (isTakenSeat) {
    return (
      <div
        className={styles.gameTableTakenSeatContainer}
        style={{
          position: "absolute",
          left: coordinates.left,
          top: coordinates.top,
        }}
      >
        <Player
          tempTableId={tempTableId}
          position={position}
          clientChairIndex={clientChairIndex}
        />
      </div>
    );
  }

  return doesExist(playerSeat) && !isReservedSeat ? null : (
    <div
      onClick={handleReserveSeat}
      className={styles.gameTableSeatContainer}
      style={{
        position: "absolute",
        left: coordinates.left,
        top: coordinates.top,
      }}
    >
      {isReservedSeat ? (
        <img style={{ color: "var(--color-b-main)" }} src={gameAssets.reserved} alt='reserved' />
      ) : (
        <Lottie
          animationData={gameAssets.takeSeatLottie}
          loop={true}
          style={{ width: 100, height: 100 }}
        />
      )}
    </div>
  );
}
